var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.viewname,{key:_vm.updated,tag:"component",attrs:{"cloudaccount":_vm.cloudaccount,"cloudregions":_vm.cloudregions,"loading":_vm.loading},on:{"changeView":_vm.changeView}})
}
var staticRenderFns = []

export { render, staticRenderFns }